import React, { useState, useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import * as TipoDeError from "../../isp._comun/services/Errores";
// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import DialogoQueryAsociadosLayout from "./layouts/DialogoQueryAsociadosLayout";
import QueryAsociadoReducer     from "../reductores/QueryAsociadoReducer";
import BuscarAsociadosAFacturar from "../reductores/acciones/dispatch/BuscarAsociadosAFacturar";
import CargaDeAsociadosBuscados from "../reductores/acciones/dispatch/CargaDeAsociadosBuscados";
import FinalizarComando        from "../reductores/acciones/dispatch/FinalizarComando";
import ServiceQueryAsociados    from "../../isp.žapi.asociados/ServiceQueryAsociados";

// import { NotificacionToastDeError } from "../../../all/componentes/widgets/Notificaciones";

// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import DataDeRespuestas_Facturacion from "../../servicios/DataEstaticaDeRespuestas.json";

// import ServicioDeQueryDeUnAsociadoAFacturar from "../../servicios/ServicioDeQueryDeUnAsociadoAFacturar";

const DialogoQueryAsociados = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryAsociadoReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloAsociado: false,
        },
        // idAsociadoSelec: null,
    });

    // const buscarAsociadosAFacturar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
    const buscarAsociadosAFacturar = async (paramsQuery) => {
        /* const asociadoAFactPorActualizar = {
            id: estadoDCF.domain.screen.idAsociado,
            data: estadoDCF.domain.update,
        }; */
        dispatchQ(new BuscarAsociadosAFacturar());

        try {
            const respuestaQuery = await new ServiceQueryAsociados().ejecutar(paramsQuery);
            dispatchQ(new CargaDeAsociadosBuscados(respuestaQuery.asociados));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarAsociado(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    return (
        <DialogoQueryAsociadosLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarAsociadosAFacturar={buscarAsociadosAFacturar}
        />
    );
};

export default DialogoQueryAsociados;
